var _g, _g2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "next_2_",
    "data-name": "next (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.904,
    height: 25.904,
    viewBox: "0 0 25.904 25.904",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55428",
    "data-name": "Group 55428",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55427",
    "data-name": "Group 55427",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85334",
    "data-name": "Path 85334",
    d: "M17.537,12.156,1.6.2A1,1,0,0,0,0,1V24.909a1,1,0,0,0,.55.891A1.012,1.012,0,0,0,1,25.9a1,1,0,0,0,.6-.2L17.537,13.75a1,1,0,0,0,0-1.594Z",
    transform: "translate(-0.002 0)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_55430",
    "data-name": "Group 55430",
    transform: "translate(21.919 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55429",
    "data-name": "Group 55429",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85335",
    "data-name": "Path 85335",
    d: "M354.991,0H353a1,1,0,0,0-1,1V24.912a1,1,0,0,0,1,1h1.993a1,1,0,0,0,1-1V1A1,1,0,0,0,354.991,0Z",
    transform: "translate(-352.002 -0.004)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.29416a896679f6f75c69ab4a0368db76.svg";
export { ForwardRef as ReactComponent };